<template>
	<Teleport to="body" v-if="display">
		<div class="w-screen h-screen flex items-start justify-end fixed top-0 left-0 bg-black/20 z-50" @mousedown.self="$emit('toggle')">
			<Transition appear>
				<div class="w-full h-full lg:w-3/6 bg-white overflow-y-scroll">
					<div
						class="flex lg:hidden bg-slate-500 text-white items-center justify-center p-3 gap-3 text-xl cursor-pointer"
						@click.prevent="$emit('toggle')">
						Fermer
					</div>
					<div class="p-5 lg:p-10 text-slate-700">
						<slot></slot>
					</div>
				</div>
			</Transition>
		</div>
	</Teleport>
</template>

<script setup>
	const props = defineProps({
		display: {
			type: Boolean,
			default: false,
		},
	});

	const emit = defineEmits(['toggle']);
</script>
